// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3G-zs","head":"ProcedureTableInfo_head__2xxz2"};